import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { logoutUser } from '../../redux/actions/user';
import { useSelector, useDispatch } from 'react-redux';

export function AdminProtectedRoute(props) {
  const location = useLocation();
  const { component: Component, ...rest } = props;
  const { user } = useSelector((state: any) => ({ user: state.user }));
  const dispatch = useDispatch();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (user !== null) {
          if (user.isAuthenticated && user.currentRole.isAdmin) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/',
                }}
              />
            );
          }
        } else {
          // important clears the current user since the data is invalid
          dispatch(logoutUser());
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: location,
                },
              }}
            />
          );
        }
      }}
    />
  );
}

// const mapStateToProps = (state: any) => {
//   return {
//     user: state.user,
//   };
// };

// /*
// export default connect(mapStateToProps, { logoutUser })(AdminProtectedRoute);
// */
